module.exports = __webpack_public_path__ + "img/图层 1495 拷贝@2x.e2bd2126.png";